import type { UseFormReturn } from "react-hook-form";

import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import type { TimeSettingsFormValues } from "../../types";
import { OVERTIME_RATE_FIELDS } from "../../utils/schedule";

export function OvertimeRatesForm({
	form,
}: {
	form: UseFormReturn<TimeSettingsFormValues>;
}) {
	const {
		register,
		formState: { errors },
	} = form;

	return (
		<div className="overtime-rates-form">
			{OVERTIME_RATE_FIELDS.map((rate) => {
				const id = `overtime-${rate.name}`;
				const error = errors[rate.name];
				return (
					<div key={rate.name} className="form-group">
						<Label htmlFor={id}>{rate.label} (%)</Label>
						<div className="overtime-rates-form__input">
							<Input
								id={id}
								inputMode="decimal"
								aria-invalid={!!error}
								{...register(rate.name)}
							/>
							<span aria-hidden="true">%</span>
						</div>
						{error && <p className="form-error">{error.message}</p>}
					</div>
				);
			})}
		</div>
	);
}
